<template>
  <div
    v-if="isPermittedAll([
      'EmployeesGetAll',
    ])"
    class="employees-form-table">
    <!-- Label / Actions -->
    <div class="d-flex align-end">
      <!-- Label -->
      <label class="line-height-1 mb-1">Employees:</label>
      <!-- / Label -->

      <!-- Actions -->
      <div class="ml-auto mb-2 d-flex align-center">
        <!-- Include Hidden -->
        <v-checkbox
          v-if="isPermittedAll([
            'EmployeesViewDeleted',
          ])"
          v-model="hiddenStatus"
          @change="getCustomerEmployees"
          label="Include Hidden"
          class="mt-0 pt-0"
          true-value="ShowAny"
          false-value="ShowNotHidden"
          hide-details>
        </v-checkbox>
        <!-- / Include Hidden -->

        <!-- Add -->
        <v-btn
          v-if="isPermittedAll([
            'EmployeesCreate',
          ]) && !hideAddButton"
          class="square ml-3"
          title="Add Employee"
          type="button"
          color="primary"
          :disabled="$store.getters.isLoadingActive"
          @click="$store.dispatch(
              'openEmployeeModalForm',
              {
                employee: {
                  CustomerID: customerId,
                },
              },
            )"
          block>
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <!-- / Add -->
      </div>
      <!-- / Actions -->
    </div>
    <!-- / Label / Actions -->

    <!-- Table -->
     <div style="overflow-y: auto" v-if="isMobile">
      <v-expansion-panels multiple v-model="expanded" class="custom-expansion">  
        <v-expansion-panel
          v-for="(employee, i) in mobileFilteredCustomerEmployees"
        >
          <v-expansion-panel-header>
            <div  v-if="expanded.includes(i) === false">
              {{ employee.EmployeeName }}
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div>
              <div>
                <b>Employee</b>
                <p>{{ employee.EmployeeName }}</p> 
              </div>
              <div>
                <b>Phone</b>
                <p>{{ employee.EmployeePhone1 }}</p>
              </div> 
              <div>
                <b>Email</b>
                <p>{{ employee.EmployeeEmail }}</p> 
              </div>
              <div class="d-flex">
                <div>
                  <b>Notes</b>
                  <p>{{ employee.EmployeeNotes }}</p> 
                </div>     
                  <v-btn 
                    @click="$store.dispatch(
                      'openEmployeeModalForm',
                      {
                        employee: {
                          EmployeeID: employee.EmployeeID,
                        },
                      }
                    )"
                    type="button"
                    color="primary"
                    outlined
                    class="ml-auto align-self-center">
                    Edit
                  </v-btn>
                </div>
              </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>

    <v-data-table v-else
      class="form-table"
      :headers="employeeFields"
      :items="customerEmployees"
      mobile-breakpoint="-1"
      item-key="EmployeeID"
      dense
      disable-pagination
      hide-default-footer
      fixed-header
      :options="{
        sortBy: ['EmployeeName'],
        rowsPerPage: -1,
      }">
      <template
        v-slot:item="row">
        <tr
          :class="{
            'hidden-table-row': row.item.EmployeeIsDeleted
          }">
          <td class="action-column">
            <v-btn
              v-if="isPermittedAll([
                'EmployeesGetByID',
              ])"
              class="square plain"
              @click="$store.dispatch(
                'openEmployeeModalForm',
                {
                  employee: {
                    EmployeeID: row.item.EmployeeID,
                  },
                }
              )"
              :disabled="$store.getters.isLoadingActive">
              <v-icon size="16px">mdi-square-edit-outline</v-icon>
            </v-btn>
          </td>
          <td>{{row.item.EmployeeName}}</td>
          <td>{{row.item.EmployeePhone1}}</td>
          <td>{{row.item.EmployeeEmail}}</td>
          <td style="max-width: 300px;">{{row.item.EmployeeNotes}}</td>
        </tr>
      </template>
    </v-data-table>
    <!-- / Table -->
  </div>
</template>

<script>
import EventBus from '../event-bus';

export default {
  name: 'CustomerEmployeesFormTable',
  props: [
    'customerId',
    'hideAddButton',
  ],
  data() {
    return {
      expanded: [],
      hiddenStatus: 'ShowNotHidden',
      customerEmployees: [],
      mobileFilteredCustomerEmployees: [],
      employeeFields: [
        {
          text: '',
          value: 'action',
          sortable: false,
          class: 'action-column',
        },
        {
          text: 'Employee',
          value: 'EmployeeName',
        },
        {
          text: 'Phone',
          value: 'EmployeePhone1',
        },
        {
          text: 'Email',
          value: 'EmployeeEmail',
        },
        {
          text: 'Notes',
          value: 'EmployeeNotes',
        },
      ],
    };
  },
  methods: {
    getCustomerEmployees() {
      this.$store.dispatch('getCustomerEmployees', {
        params: {
          HiddenStatus: this.hiddenStatus,
          CustomerID: this.customerId,
        },
      }).then((customerEmployees) => {
        this.customerEmployees = customerEmployees;
        if(this.customerEmployees) {
          this.mobileFilteredCustomerEmployees = this.customerEmployees;
          
          if (this.hiddenStatus === 'ShowNotHidden') {
            this.mobileFilteredCustomerEmployees.filter(x => x.EmployeeIsDeleted === false)
          } 
           
          this.mobileFilteredCustomerEmployees.sort((a, b) => a.EmployeeName.localeCompare(b.EmployeeName));
        }
      });
    },
  },  
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  },
  created() {
    this.getCustomerEmployees();
    EventBus.$on('getCustomerEmployees', this.getCustomerEmployees);
  },
  destroyed() {
    EventBus.$off('getCustomerEmployees', this.getCustomerEmployees);
  },
};
</script>

<style lang="scss"></style>
